import * as d3 from 'd3';

export type Point2D = [number, number];

export function getLineGenerator() {
  return d3
    .line<Point2D>()
    .x(d => d[0])
    .y(d => d[1])
    .curve(d3.curveLinear);
}

export interface ArrowHead {
  shaftEnd: Point2D;
  leftBase: Point2D;
  rightBase: Point2D;
}

// `start` -> `end` and the head sizes must be in the SAME units
// (image-pixel for the display overlay; image-pixel * scaleFactor for the
// screen-space adjust overlay). Returns null for a degenerate arrow.
export function arrowHeadGeometry(
  start: Point2D,
  end: Point2D,
  headLength: number,
  headWidth: number,
): ArrowHead | null {
  const dx = end[0] - start[0];
  const dy = end[1] - start[1];
  const length = Math.hypot(dx, dy);
  if (length < 1e-6) return null;

  const ux = dx / length;
  const uy = dy / length;
  const shaftEnd: Point2D = [end[0] - ux * headLength, end[1] - uy * headLength];
  const perpX = -uy;
  const perpY = ux;
  return {
    shaftEnd,
    leftBase: [shaftEnd[0] + perpX * headWidth, shaftEnd[1] + perpY * headWidth],
    rightBase: [shaftEnd[0] - perpX * headWidth, shaftEnd[1] - perpY * headWidth],
  };
}

// Preserve original index order (head/tail) during an endpoint drag.
export function reorderEndpoints<T>(
  staticPointIndex: number,
  staticPoint: T,
  movingPoint: T,
): [T, T] {
  const pts = [] as unknown as [T, T];
  pts[staticPointIndex] = staticPoint;
  pts[1 - staticPointIndex] = movingPoint;
  return pts;
}
